module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    staticClass: "modal-mask"
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('h3', [_vm._v("Download Markdown")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('textarea', {
    staticStyle: {
      "height": "80vh",
      "width": "100%"
    },
    domProps: {
      "textContent": _vm._s(this.$store.state.finalMarkdown)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer pure-g"
  }, [_c('div', {
    staticClass: "pure-u-1-12"
  }, [_c('vue-r-button', {
    attrs: {
      "label": 'Download',
      "disabled": true
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "pure-u-5-6"
  }), _vm._v(" "), _c('div', {
    staticClass: "pure-u-1-12"
  }, [_c('vue-r-button', {
    attrs: {
      "label": 'Close',
      "onClick": _vm.closeModal
    }
  })], 1)])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2532241a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/downloadModal.vue
// module id = 60
// module chunks = 0